module.exports = __webpack_public_path__ + "static/media/3d-rendering-modern-classic-bathroom-with-luxury-t-KFHCU6G.48312a7a.jpg";